module.exports = __webpack_public_path__ + "img/pool-bg.4b9ba997.svg";